import { applyMiddleware, createStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import * as Store from './reducers';
import rootSaga from './sagas';

const sagaMiddleware = createSagaMiddleware();

const store = createStore(
  Store.reducer,
  Store.initialState,
  applyMiddleware(sagaMiddleware)
)

sagaMiddleware.run(rootSaga, store.dispatch);

// export the actual store
export default store;